import * as React from 'react';
import { Route, Switch } from 'react-router';

import { LoginPageContainer } from './login-page/login-page';
import { ForgotPasswordContainer } from './forgot-password/forgot-password';
import { ResetConfirmContainer } from './reset-confirm/reset-confirm';
import { ResetPasswordContainer } from './reset-password/reset-password';
import { SignUpEmailContainer } from './sign-up-email/sign-up-email';
import { SignUpPasswordContainer } from './sign-up-password/sign-up-password';
import { SignUpWelcomeContainer } from './sign-up-welcome/sign-up-welcome';
import { Welcome } from './welcome/welcome';
import { ErrorPage } from 'src/core/components/error-page/error-page';

export const LoginRoutes: React.SFC = () => (
    <Switch>
        <Route exact path="/login" component={LoginPageContainer} />
        <Route exact path="/login/welcome" component={Welcome} />
        <Route exact path="/login/forgot" component={ForgotPasswordContainer} />
        <Route exact path="/login/reset/confirm" component={ResetConfirmContainer} />
        <Route
            exact
            path="/login/reset/:token"
            render={(props) => <ResetPasswordContainer {...props} step={1} />}
        />
        <Route
            exact
            path="/login/reset/:token/2"
            render={(props) => <ResetPasswordContainer {...props} step={2} />}
        />
        <Route exact path="/login/sign-up" component={SignUpEmailContainer} />
        <Route exact path="/login/sign-up/:token/welcome" component={SignUpWelcomeContainer} />
        <Route
            exact
            path="/login/sign-up/:token"
            render={(props) => <SignUpPasswordContainer {...props} step={1} />}
        />
        <Route
            exact
            path="/login/sign-up/:token/2"
            render={(props) => <SignUpPasswordContainer {...props} step={2} />}
        />
        <Route component={() => <ErrorPage type="not-found" />} />
    </Switch>
);
